module.exports = __webpack_public_path__ + "static/media/diamond.ff3a14aa.svg";